import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";
import { getAsBoolean } from "src/uicomponents/components/utilities";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class ClassHtmlBridgePrototype extends HtmlBridgePrototype{

    public className:string;
    
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new ClassHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class ClassHtmlBridge extends HtmlBridge{
    
    private className:string;
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:ClassHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.className = prototype.className;
    }
    
    public set value(v: boolean) { 
        this._value = getAsBoolean(v); 
        if(this._value===true){
            new elementClassAdderRemover().addClass(this.element,this.className);
        }else{
            new elementClassAdderRemover().removeClass(this.element,this.className);
        }
    } public get value(): boolean { return this._value;} private _value: boolean;
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }

    public release(){
        this.binding.release();
    }
}

export class elementClassAdderRemover{
    public addClass(element:Element,className:string){
        if(stringIsNullOrEmpty(className))
            return;
        let elementPropertyName = `__binder__classes__count__${className}`;
        this.createElementProperty(element,className);
        element[elementPropertyName] =element[elementPropertyName]+1;
        element.classList.add(className); 
    }
    public removeClass(element:Element,className:string){
        if(stringIsNullOrEmpty(className))
            return;
        let elementPropertyName = `__binder__classes__count__${className}`;
        this.createElementProperty(element,className);
        if(element[elementPropertyName]<=1){
            element[elementPropertyName]=0;
            element.classList.remove(className);
        }
    }

    private createElementProperty(element:Element,className:string){
        let elementPropertyName = `__binder__classes__count__${className}`;
        if(element[elementPropertyName]==null){
            element[elementPropertyName] = element.classList.contains(className) ? 1 : 0;
        }
    }
} 